import { getDetails } from '@/api/admin/user';

const validateUsername = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入用户名'));
  }
  getDetails(value).then((response) => {
    if (window.boxType === 'edit') callback();
    let result = response.data.data;
    if (result !== null && typeof result != 'undefined') {
      callback(new Error('用户名已经存在'));
    } else {
      callback();
    }
  });
};
let validateTrid = (rule, value, callback) => {
  let reg = /^WE.*TR$/;
  if (value === '') {
    callback(new Error('请输入译员ID'));
  } else if (String(value).search(reg) < 0) {
    callback(new Error('格式有误，要以’WE‘开头，’TR‘结尾'));
  } else {
    callback();
  }
};
export const tableOption = {
  card: false,
  page: true,
  border: true,
  index: true,
  indexLabel: '序号',
  align: 'center',
  refreshBtn: true,
  emptyBtn: true,
  // header: false, //表格头部中间菜单
  menu: true,
  menuType: 'text',
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  searchSpan: 4,
  searchMenuSpan: 3,
  searchMenuPosition: 'left', //v2.7.9+
  menuWidth: 200,
  labelWidth: 115,
  searchLabelWidth: 75,
  searchIcon: false,
  emptyText: '',
  column: [
    {
      label: '译员ID',
      prop: 'trId',
      span: 24,
      hide: true,
      addDisplay: true,
      editDisplay: false,
      editDisabled: true,
      formslot: true,
    },
    {
      label: '手机号/邮箱',
      prop: 'username',
      searchLabelWidth: 100,
      search: true,
      searchSpan: 5,
      addDisabled: true,
      editDisabled: true,
      rules: [
        {
          required: true,
          message: '请输入用户名',
        },
        {
          min: 3,
          max: 20,
          message: '长度在 3 到 20 个字符',
          trigger: 'blur',
        },
        { validator: validateUsername, trigger: 'blur' },
      ],
    },
    {
      label: '姓名',
      prop: 'realname',
      searchSpan: 3,
      addDisabled: true,
      editDisabled: true,
      rules: [
        {
          required: true,
          message: '请填写姓名',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '密码',
      prop: 'password',
      type: 'password',
      addDisabled: true,
      editDisabled: true,
      editDisplay: false,
      value: '',
      hide: true,
    },
    {
      label: '译员ID',
      prop: 'id',
      searchSpan: 3,
      addDisplay: false,
      editDisabled: true,
      rules: [
        {
          required: true,
          message: '请填写译员ID',
          trigger: 'blur',
        },
        { validator: validateTrid, trigger: 'blur' },
      ],
    },
    {
      label: '资源类型',
      prop: 'userType',
      type: 'select',
      search: true,
      width: 70,
      addDisplay: false,
      editDisplay: false,
      dicData: [
        {
          label: '兼职',
          value: 'PT',
        },
        {
          label: '全职',
          value: 'FT',
        },
        {
          label: '公司',
          value: 'CO',
        },
      ],
    },
    /* {
      label: '擅长领域',
      prop: 'industryList',
      slot: true,
      span: 24,
      searchslot: true,
      searchLabelWidth: 0,
      formslot: true,
      overHidden: true,
    },
    {
      label: '是否签约',
      prop: 'isSign',
      searchSpan: 4,
      type: 'select',
      search: true,
      slot: true,
      width: 70,
      rules: [
        {
          required: true,
          message: '请选择是否签约',
          trigger: 'blur',
        },
      ],
      dicData: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
    },
    {
      label: '获取订单方式',
      prop: 'isMatchName',
      slot: true,
      span: 24,
      formslot: true,
    }, */
    {
      label: '信用分',
      prop: 'score',
      width: 70,
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '解禁时间',
      prop: 'disableTime',
      type: 'datetime',
      format: 'yyyy-MM-dd hh:mm:ss',
      valueFormat: 'timestamp',
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'datetime',
      format: 'yyyy-MM-dd hh:mm:ss',
      valueFormat: 'timestamp',
      addDisplay: false,
      editDisplay: false,
    },
    {
      label: '账号状态',
      prop: 'status',
      type: 'switch',
      search: true,
      searchSpan: 4,
      slot: true,
      width: 70,
      activeColor: '#ff4949',
      inactiveColor: '#13ce66',
      addDisplay: false,
      editDisplay: false,
      dicData: [
        {
          label: '启用',
          value: 'y',
        },
        {
          label: '禁用',
          value: 'n',
        },
      ],
    },
  ],
};
